/*
    * This class inherits DrawFeature control. It adds a keyboard handler to manage ESCAPE
    * and DELETE key press.
    */
ALKMaps.Control.DrawFeatureOpt = ALKMaps.Class(ALKMaps.Control.DrawFeature, {
  handlers: null,
  initialize: function (layer, handler, options) {
    ALKMaps.Control.DrawFeature.prototype.initialize.apply(this, [layer, handler, options]);
    // configure the keyboard handler
    var keyboardOptions = {
      keydown: this.handleKeypress
    };
    this.handlers = {
      keyboard: new ALKMaps.Handler.Keyboard(this, keyboardOptions)
    };
  },
  handleKeypress: function (param) {},
  activate: function (param) { },
  deactivate: function (param) {
  },

  CLASS_NAME: "ALKMaps.Control.DrawFeatureOpt"
});


// WEBPACK FOOTER //
// ./app/alkmapsExtension/controlDrawFeatureOpt.js